<template>
  <div class="page_dashboard">
    <h1>Přehled</h1>
    <div class="price">
      <a href="#finance">
        <h2>Finance</h2>
      </a>
      <label data-label="price">Celková cena</label>
      <div data-holder="price">{{ price_total | currency }}</div>
      <label data-label="paid">Zaplaceno</label>
      <div data-holder="paid">{{ paid | currency }}</div>
      <label data-label="remains">{{ remains >= 0 ? 'Zbývá' : 'Přeplatek' }}</label>
      <div data-holder="remains">{{ Math.abs(remains) | currency }}</div>
      <label data-label="price_participants">Cena za účastníky</label>
      <div data-holder="price_participants">{{ price_participants | currency }}</div>
      <label data-label="price_acc">Cena za ubytování</label>
      <div data-holder="price_acc">{{ price_acc | currency }}</div>
      <label data-label="price_shirts">Cena za trička</label>
      <div data-holder="price_shirts">{{ price_shirts | currency }}</div>
      <label data-label="price_other">Ostatní</label>
      <div data-holder="price_other">{{ price_other | currency }}</div>
    </div>
    <div v-if="Object.keys(requests).length > 0" class="requests">
      <h2>Požadavky na hráče z ostatních hlídek</h2>
      <div v-for="(participant, id) in requests" :key="`req_${id}`" class="request">
        <div class="name">{{ teams[participant.teamId].outpostId }}. PH: {{ participant | participant_name }}</div>
        <button @click="acceptPlayer(id)" class="accept" title="Přijmout">
          <i class="fa fa-check"></i>
        </button>
        <button @click="rejectPlayer(id)" class="reject" title="Odmítnout">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="acc">
      <a href="#accommodation">
        <h2>Ubytování</h2>
      </a>
      <template v-for="(count, acc) in accommodationGroups">
        <label :data-label="acc" :key="`label-${acc}`">{{ acc | cz }}</label>
        <div :data-holder="acc" :key="`holder-${acc}`">{{ count | cz_beds }}</div>
      </template>
    </div>
    <div class="teams">
      <a href="#teams">
        <h2>Týmy</h2>
      </a>
      <div class="team" v-for="(team, teamName) in team_members" :key="teamName">
        <div class="label">{{ teams[teamName] | team_name_full }}</div>
        <div v-for="(member, id) in team" :key="id" class="member">{{ member | participant_name }}</div>
      </div>
    </div>
    <div class="roy">
      <h2>Ranger roku</h2>
      <div v-for="(cat, royCat) in royNotEmpty" :key="royCat" class="category">
        <div class="label">{{ royCat | cz }}</div>
        <div v-for="(participant, id) in cat" :key="id">{{ participant | participant_name }}</div>
      </div>
    </div>
    <div class="participants">
      <a href="#participants">
        <h2>Účastníci ({{ Object.keys(myPlayingParticipant).length }})</h2>
      </a>
      <div
        v-for="(participant, id) in myPlayingParticipant"
        :key="id"
      >{{ participant | participant_name }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { _ } from "../extend";

export default {
  name: "dashboard",
  computed: {
    ...mapState(["teams"]),
    ...mapGetters([
      "myPlayingParticipant",
      "myFinanceParticipant",
      "team_members",
      "price_participants",
      "price_acc",
      "price_other",
      "price_total",
      "paid",
      "remains"
    ]),
    accommodationGroups() {
      return _.select(
        _.groupBy(
          this.$store.getters.myAccommodation,
          (acc, id) => id.split("-")[0]
        ),
        accGroup => _.sum(accGroup, acc => acc.amount)
      );
    },
    royNotEmpty() {
      return _.filter(
        this.$store.getters.roy,
        members => Object.keys(members).length > 0
      );
    },
    requests() {
      return _.filter(
        this.$store.state.participants,
        participant =>
          !participant.isTeamConfirmed &&
          participant.teamId != null &&
          participant.playingOutpostId == this.$store.state.outpost.id
      );
    },
    price_shirts() {
      return _.sum(this.$store.state.shirts, shirtCount => shirtCount) *
        this.$store.state.config.shirtPrice;
    }
  },
  methods: {
    acceptPlayer(id) {
      this.$store.commit("update", {
        paths: ["participants", id, "isTeamConfirmed"],
        value: true
      });
    },
    rejectPlayer(id) {
      this.$store.commit("update", {
        paths: ["participants", id, "teamId"],
        value: null
      });
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.page_dashboard
  display: grid
  max-width: $w-content
  margin: 2rem auto

  grid-template-columns: 1fr 1fr 1fr
  grid-gap: 10%

  h1
    grid-row: 1
    grid-column: 1 / 4
  h2
    display: block
    margin: -1rem -1rem 1rem -1rem
    padding: 1rem
    text-align: center
    border-bottom: 1px solid #aaa
    background-color: #eee
  .price, .acc, .participants, .teams, .roy, .requests
    padding: 1rem
    border-radius: 5px
    overflow: hidden
  .price, .acc
    display: grid

    grid-template-columns: auto auto
    grid-column-gap: 10px
    grid-row-gap: .3rem
    align-content: start
    a
      grid-column: 1 / -1
      grid-row: 1
    [data-label]
      grid-column: 1
      text-align: right
    [data-holder]
      grid-column: 2
      text-align: right
      &[data-holder=remains]
        margin-bottom: 1rem
  .acc
    [data-holder]
      text-align: left

  .participants
    grid-column: 3
    grid-row: 2 / span 2
    div
      padding: .5rem
      &:nth-child(2n)
        background-color: $bc-secondary-light
  .teams
    .team
      display: grid
      padding: .5rem
      grid-template-columns: 1fr 1fr
      &:nth-child(2n)
        background-color: $bc-secondary-light
      .label
        grid-column: 1
        font-weight: bold
      .member
        grid-column: 2

  .roy
    .category
      .label
        margin-top: 1rem
        font-weight: bold
      ::not(.label)
        margin-left: 1rem
  .requests
    .request
      display: flex
      margin-bottom: 5px
      align-items: center
      .name
        flex-grow: 1
      .accept
        @include button-primary()
        @include first-input()
      .reject
        @include button-danger()
        @include last-input()
</style>